import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import { CircularProgress } from "@mui/material";
import { Close } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import TagList from "../../../components/TagList/TagList";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import * as actions from "../../../store/actions";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

//###
import axios from "axios";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { __ } from "../../../translations/utils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

function BlockedPaymentMethod({ ...props }) {
  const { classes } = props;
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [blockedPaymentMethods, setBlockedPaymentMethods] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);

  /**
   * Component did mount
   */
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);

    axios
      .all([
        axios.get("/core/vestigingen/" + props.vestiging_id),
        axios.get("/core/vestigingen/" + props.vestiging_id + "/getpaymethods"),
      ])
      .then(
        axios.spread((payCommisionResponse, paymentMethodsResponse) => {
          setBlockedPaymentMethods(JSON.parse(payCommisionResponse.data.data.blockedPaymentMethods));
          setPaymentMethods(paymentMethodsResponse.data.data.paymentMethods);
          setLoading(false);
        })
      );
  };

  const save = () => {
    setSaving(true);

    let savedData = null;

    if (Array.isArray(blockedPaymentMethods) && blockedPaymentMethods.length > 0) {
      savedData = JSON.stringify(blockedPaymentMethods);
    }

    let data = {
      _method: "PATCH",
      blockedPaymentMethods: savedData,
    };

    axios.post("core/vestigingen/" + props.vestiging_id, data).then((response) => {
      getData();
      setSaving(false);
    });
  };

  const convertPaymethods = paymentMethods.map((paymentMethod) => {
    return { id: paymentMethod.value, label: paymentMethod.label };
  });

  const handleChange = (blockedMethods) => {
    setBlockedPaymentMethods(blockedMethods);
  };

  return (
    <div>
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={props.toggle}
        open={props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"geblokkerdere betaal methodes."} tKey={"blockedPaymentMethod.header"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          {loading ? (
            <div className={classes.loadingMain}>
              <CircularProgress className={classes.loadingIcon} />
            </div>
          ) : null}

          {!loading ? (
            <div>
              <GridContainer>
                <GridItem md={12} sm={12} xs={12}>
                  <TagList
                    dropdownText={"Selecteer een betaalmethode"}
                    headerText={"Selecteer een betaalmethode"}
                    items={convertPaymethods}
                    onChange={handleChange}
                    selectedItems={blockedPaymentMethods ?? []}
                    selectedText={"Geblokkeerde betaalmethodes"}
                    singleSelect
                  />
                </GridItem>
              </GridContainer>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={__("vestigingen", "modal.blockedpayments.button.save", "Aanpassingen opslaan")}
            disabled={false}
            key={"savebutton"}
            onClick={save}
            saving={saving}
            type={"button"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    userLocale: state.user.lang,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BlockedPaymentMethod, notificationsStyle));
